/** Dora App specific DataTypes relating to the ProductCatalogue component from Dora Components */
import { ProductCard } from '@dora/components';
import { CatalogueEntry } from './catalogueEntry';
import { getLeadTime } from './leadTime';
import * as Summary from './summary';

export type PCProduct = ProductCard.Product & { id: string };

export const idFromCatalogueEntry = (ce: CatalogueEntry) =>
    ce.furnitureDescription.configurationTemplateId;

export const fromCatalogueEntry = (
    ce: CatalogueEntry,
    toLocalePrice: (price: number) => string,
) => ({
    id: idFromCatalogueEntry(ce),
    // TODO: compose with CatalogueEntry for ease of use
    imageUrl: Summary.getImage(ce.summary),
    title: Summary.getName(ce.summary),
    price: toLocalePrice(ce.price),
    leadTime: getLeadTime(ce.furnitureDescription.variants.map(p => p.leadTime)),
});

export const findCatalogueEntry = (id: string, catalogueEntries: CatalogueEntry[]) =>
    catalogueEntries.find(ce => idFromCatalogueEntry(ce) === id);
